import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { companyTask } from '../companyTask';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TaskService } from 'src/app/services/task.service';
import { GroupMasterService } from 'src/app/services/group-master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { ProcessMasterService } from 'src/app/services/process-master.service';
import { AlertComponent } from '../../alert/alert.component';
import { DocumentManagementMasterService } from 'src/app/services/document-management-master.service';
declare var $: any;
import * as _ from 'lodash';
import { Enums } from 'src/app/helpers/enums';
import { Component, OnInit, OnDestroy, QueryList, ViewChild } from '@angular/core';
import { SharerService } from 'src/app/services/sharer.service';
import { ChangeDetectorRef } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';


@Component({
  selector: 'app-activated-company-task-list',
  templateUrl: './activated-company-task-list.component.html',
  styleUrls: ['./activated-company-task-list.component.css']
})
export class ActivatedCompanyTaskListComponent implements OnInit, OnDestroy {

  public environmentSettings: any;

  isCollapsed = true;
  isSearchCollapsed: boolean = true;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();

  @ViewChild(DataTableDirective)
  dtElement1: DataTableDirective;
  dtOptions1: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger1: Subject<any> = new Subject();

  uploadProofactivatedTaskForm: FormGroup;
  activatedProcessTasksForm: FormGroup;
  selectedTaskForm: FormGroup;
  companytasklist: any[] = [];
  groupTypes: any[];
  groupID: any;
  taskStatusID: any;
  activatedTasklist: any;
  isLoading: boolean = false;
  taskStatusTypes: any[];
  forkJoinStream: any;
  SearchtaskEventbasedorPeriodicModel: any;
  IsEmailSend: any;
  SearchtaskUserdefinedorPredefinedModel: any;
  CompletedDateModel: any;
  processes: any[];
  selectedAll: any;
  IsSelectedTasks: any;
  processType: string;
  fileUpload: any;
  filesToUpload: Array<File>;
  orignalName: any;
  fileName: any;
  fileuploadstatus: any;
  TaskStatusModel: any;
  IsSelectedUpload: any;
  originalfileName: string;
  currentURL: any;
  onlySenEmailTaskButtonEnable: boolean = false;

  selectedNewDocumentCompanytasks = [];
  selectedUpdatedDocumentCompanytasks = [];

  selectedCompanytasks: companyTask[] = [];
  selectedCompanytasksSendEmail: companyTask[] = [];
  immediateReminderMailSelectedCompanytasks: companyTask[] = [];
  todaysDate: any;
  immediateReminderMail: any;
  documentId: string;
  hasPermission: any;
  groupname: any = null;
  selcettaskname: any = null;

  ToAssignedTo: Boolean = false;
  OneEscalation: Boolean = false;
  TwoEscalation: Boolean = false;
  ResponsibleUser: Boolean = false;
  ResponsibleUserone: Boolean = false;
  ResponsibleUsertwo: Boolean = false;
  AssignedTocc: Boolean = false;
  OneEscalationcc: Boolean = false;
  TwoEscalationcc: Boolean = false;
  ResponsibleUsercc: Boolean = false;
  ResponsibleUseronecc: Boolean = false;
  ResponsibleUsertwocc: Boolean = false;
  private cachedUsersList$: Observable<any> | null = null;
  Collegues: Boolean = false;
  Records = [];
  IsSentIntimationFormValid = false;


  minDateForSearchFrom: NgbDateStruct;
  minDateForSearchTo: NgbDateStruct;
  todayDateforSearchMeeting: NgbDateStruct;
  activatedTaskSearchDateFrom: NgbDateStruct;
  activatedTaskSearchDateTo: any;
  searcheFilteredDataTask: any[];
  response: any;
  IsEmailSendActivatedTask: boolean = false;
  assignedusers: any[];
  isPeriodicConfigurationAvailable: boolean = false;
  configId: any;
  taskConfigurationForm: FormGroup;
  disabledOnclick: boolean;
  fileExtension: boolean = true;
  taskTriggerTypes: any[];
  triggerId: any;
  typeHasError: boolean = true;
  FileOrignalName: any;
  changedName: any;
  titleOnAddUpdate: any;
  pdfArray1 = [];
  taskProofData = [];
  documentIdToDelete = '';
  pdfToDelete = '';
  taskId: any;
  cronConfigurationForm: FormGroup;
  cronConfigurations = [];
  cronFrequencyData: any = [];
  cronDate: NgbDateStruct;
  CronDates: any = [];
  addBtn: boolean = true;

  constructor(private taskService: TaskService, private groupMasterService: GroupMasterService, private route: ActivatedRoute,
    private processService: ProcessMasterService, private router: Router, private commonFunction: CommonFunction, private alert: AlertComponent, private documentManagementService: DocumentManagementMasterService,
    private loaderService: LoaderService, private fb: FormBuilder, private cdr: ChangeDetectorRef) {
    this.taskStatusTypes = this.commonFunction.sortByKey(Enums.TaskStatus, 'name');
    // var taskstatusTypes = this.commonFunction.sortByKey(Enums.TaskStatus, 'name');
    this.taskStatusTypes.forEach(element => {
      if (element.name == 'Delayed Completion') {
        element.isDisabled = true;
      } else {
        element.isDisabled = false;
      }
    })
    // this.taskStatusTypes = $(taskstatusTypes).filter(function (i, n) { return (n.id != "3") });
    this.currentURL = window.location.href;
    this.response = false;
    // console.log("taskStatusTypes", this.taskStatusTypes)

  }
  activatedTaskData: any = [];

  toggleSearchCollapse() {
    if (this.isSearchCollapsed == true) {
      this.isSearchCollapsed = false;
    }
    else {
      this.isSearchCollapsed = true;
    }
  }

  // Get cached users list Observable
  getCachedUsersList(): Observable<any> {
    if (!this.cachedUsersList$) {
      // Use shareReplay(1) to cache the result and share it among all subscribers
      this.cachedUsersList$ = this.taskService.getUsersList().pipe(shareReplay(1));
    }
    return this.cachedUsersList$;
  }

  getActivatedTaskList() {
    this.isLoading = true;
    this.loaderService.enable();

    this.companytasklist = [];
    // if (this.dtElement.dtInstance != undefined) {
    //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //     dtInstance.destroy();
    //   });
    // }
    if ($.fn.DataTable.isDataTable('#activatedcompanytaskTable')) {
      $("#activatedcompanytaskTable").DataTable().destroy();
    }
    // Use cached Observable instead of direct service call
    let usersList = this.getCachedUsersList();

    let activatedTaskList = this.taskService.getActivatedTaskList()

    Observable.forkJoin([activatedTaskList, usersList])
      .subscribe(
        (response) => {
          this.activatedTasklist = response;
          this.activatedTaskData = [];
          const taskList = response[0]?.taskList || [];
          const usersData = response[1]?.result || [];

          const activatedtasksData = [];

          _.forEach(taskList, function (activatedTask) {
            let assignedUserName = [];
            if (activatedTask.AssignedTo && activatedTask.AssignedTo.length > 0) {
              activatedTask.AssignedTo.forEach((ele) => {
                var assignedTo = _.filter(usersData, ["_id", ele]);
                if (assignedTo && assignedTo.length > 0) {
                  assignedUserName.push(assignedTo[0].FirstName + " " + assignedTo[0].LastName)
                }
              })
            }
            _.assign(activatedTask, { AssignedUserName: assignedUserName })
            let resUser = [];
            if (activatedTask.ResponsibleUser && activatedTask.ResponsibleUser.length > 0) {
              activatedTask.ResponsibleUser.forEach((ele) => {
                var responsibleuser = _.filter(usersData, ["_id", ele]);
                if (responsibleuser && responsibleuser.length > 0) {
                  resUser.push(responsibleuser[0].FirstName + " " + responsibleuser[0].LastName)
                }
              })
            }
            _.assign(activatedTask, { ResponsibleUserName: resUser });

            activatedtasksData.push(activatedTask);
          })

          var filterActivatedtaskData = _.filter(activatedtasksData, function (activatedTask) {
            return activatedTask.TaskStatus === 4 || activatedTask.TaskStatus === 1;
          });

          this.companytasklist = filterActivatedtaskData || [];
          this.response = false;
          // Ensure view is updated before triggering DataTable
          this.cdr.detectChanges();
          setTimeout(() => {
            // Check if table element exists and data is valid before triggering DataTable
            const tableElement = document.getElementById('activatedcompanytaskTable');
            if (tableElement && Array.isArray(this.companytasklist)) {
              try {
                this.dtTrigger.next();
              } catch (error) {
                console.error('Error initializing DataTable:', error);
                // Retry once more if initialization fails
                setTimeout(() => {
                  if (document.getElementById('activatedcompanytaskTable')) {
                    this.dtTrigger.next();
                  }
                }, 300);
              }
            } else {
              // Retry if table element doesn't exist yet
              setTimeout(() => {
                if (document.getElementById('activatedcompanytaskTable') && Array.isArray(this.companytasklist)) {
                  this.dtTrigger.next();
                }
              }, 300);
            }
          }, 200);
          this.isLoading = false;
          this.loaderService.disable();
        },
        (error) => {
          console.error('Error loading activated task list', error);
          this.companytasklist = [];
          this.response = false;
          this.isLoading = false;
          this.loaderService.disable();
        }
      );



  }

  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
      .subscribe((groupList: any) => {
        if (groupList.status == 0) {
          //this.groupTypes = groupList.groupList;
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  activatedTaskSearchFromDuedateChange() {
    var dateObj = new Date();
    this.todayDateforSearchMeeting = { year: dateObj.getUTCFullYear(), month: dateObj.getUTCMonth() + 1, day: dateObj.getUTCDate() };
    this.minDateForSearchTo = this.activatedTaskSearchDateTo;

  }

  getProcessListByProcessType(processType) {
    this.processes = [];
    var ispredefined = null;
    if (processType === 'Predefined') {
      ispredefined = true;
    } else if (processType === 'Userdefined') {
      ispredefined = false;
    }

    this.processService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          var processData = $(processList.processList).filter(function (i, n) { return n.IsPredefined === ispredefined });
          this.processes = this.commonFunction.sortByKey(processData, 'ProcessName');;
        }
      })
  }

  getProcessList() {
    this.processes = [];

    this.processService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          this.processes = processList.processList;
          this.processes = this.commonFunction.sortByKey(this.processes, 'ProcessName');
        }
      })
  }

  getSelectedGroupID(event) {
    var id = event.target.value;
    this.groupID = id;
  }

  getSelectedTaskStatus(event) {
    // console.log('target value===', event.target.value);
    var id = event.target.value;
    this.taskStatusID = id;
  }

  upload() {
    var file = this.filesToUpload;
    this.makeFileRequest(environment.pssServerUrl + "documentManagement/fileUpload/", [], file).then((result) => {
      this.fileuploadstatus = result;
      // console.log(this.fileuploadstatus)
    });
  }

  makeFileRequest(url: string, params: Array<string>, files: Array<File>) {
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      for (var i = 0; i < files.length; i++) {
        var newDate = Date.now();
        formData.append("file", files[i], newDate + '-' + files[i].name.replace(',', ''));
        //this.agendaAddForm.controls.uploadFile.setValue(formData);
        this.orignalName = newDate + '-' + files[i].name.replace(',', '');
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(JSON.parse(xhr.response));
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  showTasksBySearchData() {
    this.response = true;
    var searchParameters = {
      EventBasedorPeriodic: (this.SearchtaskEventbasedorPeriodicModel === undefined) ? null : this.SearchtaskEventbasedorPeriodicModel,
      UserdefinedorPredefined: (this.SearchtaskUserdefinedorPredefinedModel === undefined) ? null : this.SearchtaskUserdefinedorPredefinedModel,
      GroupId: (this.groupID === '' || this.groupID === undefined) ? null : this.groupID,
      TaskStatusId: (this.taskStatusID === '' || this.taskStatusID === undefined) ? null : this.taskStatusID,
      FromDate: (this.activatedTaskSearchDateFrom === undefined) ? null : this.setDate(this.activatedTaskSearchDateFrom),
      ToDate: (this.activatedTaskSearchDateTo === undefined) ? null : this.setDate(this.activatedTaskSearchDateTo),
      EmailSendForTask: (this.IsEmailSend === '' || this.IsEmailSend === undefined) ? null : this.IsEmailSend,
      TriggerId: (this.triggerId == '' || this.triggerId == undefined) ? null : this.triggerId
    };

    localStorage.setItem('searchtaskc', 'true');
    localStorage.setItem('inputdata', JSON.stringify(searchParameters))
    this.selectedProcessCount = 0;
    this.selectedEventBaseCount = 0;
    // console.log('searchParameters', searchParameters);
    this.getActivatedTaskListBySearchFilter(searchParameters);
  }

  setDate(date) {
    return this.commonFunction.setDate(date);
  }

  addTaskstoActivatedProcess() {
    this.disabledOnclick = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    for (let result of this.companytasklist) {
      if (result.SelectedTask === true) {
        result.CompanyID = companyID;
        result.ProcessID = this.activatedProcessTasksForm.controls.ProcessID.value;
        this.selectedCompanytasks.push(result);
      }

    }

    var processTasksData = {
      processTasks: this.selectedCompanytasks
    }
    //this.taskService.updateCompanyTasks(companyTasks)

    this.taskService.addActivatedTaskstoProcess(processTasksData)
      .subscribe(result => {
        this.disabledOnclick = false;
        if (result.status == 0) {


          const processId = this.activatedProcessTasksForm.controls.ProcessID.value;
          $('#addtasktoprocessDialog').modal('hide');
          this.alert.successWithOk1(result.message, () => {
            ////inside popup form dialog
            $('#addtasktoprocessDialog').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');


          });

        }
        else {

          $('#addtasktoprocessDialog').modal('hide');
          this.alert.error1(result.message, () => {
            ////inside popup form dialog
            $('#addtasktoprocessDialog').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

          });
        }

        this.getActivatedTaskList();
        this.selectedCompanytasks = [];
        this.IsSelectedTasks = false;
      });

  }

  getActivatedTaskListBySearchFilter(searchParameters) {
    this.isLoading = true;
    this.loaderService.enable();
    this.companytasklist = [];
    // if (this.dtElement.dtInstance != undefined) {
    //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //     dtInstance.destroy();
    //   });
    // }
    if ($.fn.DataTable.isDataTable('#activatedcompanytaskTable')) {
      $("#activatedcompanytaskTable").DataTable().destroy();
    }
    // Use cached Observable instead of direct service call
    let usersList = this.getCachedUsersList();
    let activatedTaskList = this.taskService.getActivatedCompanyTaskListBySearchFilters(searchParameters);

    Observable.forkJoin([activatedTaskList, usersList])
      .subscribe(
        (response) => {
          this.activatedTasklist = response;
          const taskList = response[0]?.taskList || [];
          const usersData = response[1]?.result || [];

          const activatedtasksData = [];

          _.forEach(taskList, function (activatedTask) {
            let assignedUserName = [];
            if (activatedTask.AssignedTo && activatedTask.AssignedTo.length > 0) {
              activatedTask.AssignedTo.forEach((ele) => {
                var assignedTo = _.filter(usersData, ["_id", ele]);
                if (assignedTo && assignedTo.length > 0) {
                  assignedUserName.push(assignedTo[0].FirstName + " " + assignedTo[0].LastName)
                }
              })
            }
            _.assign(activatedTask, { AssignedUserName: assignedUserName })
            
            let resUser = [];
            if (activatedTask.ResponsibleUser && activatedTask.ResponsibleUser.length > 0) {
              activatedTask.ResponsibleUser.forEach((ele) => {
                var responsibleuser = _.filter(usersData, ["_id", ele]);
                if (responsibleuser && responsibleuser.length > 0) {
                  resUser.push(responsibleuser[0].FirstName + " " + responsibleuser[0].LastName)
                }
              })
            }
            _.assign(activatedTask, { ResponsibleUserName: resUser });

            activatedtasksData.push(activatedTask);
          })

          this.companytasklist = activatedtasksData || [];
          this.response = false;
          // Ensure view is updated before triggering DataTable
          this.cdr.detectChanges();
          setTimeout(() => {
            // Check if table element exists and data is valid before triggering DataTable
            const tableElement = document.getElementById('activatedcompanytaskTable');
            if (tableElement && Array.isArray(this.companytasklist)) {
              try {
                this.dtTrigger.next();
              } catch (error) {
                console.error('Error initializing DataTable:', error);
                // Retry once more if initialization fails
                setTimeout(() => {
                  if (document.getElementById('activatedcompanytaskTable')) {
                    this.dtTrigger.next();
                  }
                }, 300);
              }
            } else {
              // Retry if table element doesn't exist yet
              setTimeout(() => {
                if (document.getElementById('activatedcompanytaskTable') && Array.isArray(this.companytasklist)) {
                  this.dtTrigger.next();
                }
              }, 300);
            }
          }, 200);
          this.isLoading = false;
          this.loaderService.disable();
        },
        (error) => {
          console.error('Error loading activated task search list', error);
          this.companytasklist = [];
          this.response = false;
          this.isLoading = false;
          this.loaderService.disable();
        }
      );


  }

  showaddTasktoProcessDialog() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#addtasktoprocessDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#addtasktoprocessDialog').modal('show');
    }, 100);
    this.activatedProcessTasksForm.controls.ProcessID.setValidators([Validators.required]);
    this.activatedProcessTasksForm.controls.ProcessID.updateValueAndValidity();

  }

  getTaskStatus(duedate, completeddate, taskStatus) {

    var text = "";
    var dueDate = (duedate != null || duedate != undefined) ? duedate : null;
    var completeddate = (completeddate != null || completeddate != undefined) ? completeddate : null;
    if (dueDate != null && completeddate != null) {
      if (completeddate > dueDate) {
        text = this.getStatusforTask(3);
      }
      else {
        text = this.getStatusforTask(taskStatus);
      }
    }
    else {
      text = this.getStatusforTask(taskStatus);
    }
    return text;
  }

  CheckProcessType(item: any) {
    this.processType = item;
    this.getProcessListByProcessType(this.processType);
  }

  getStatusforTask(taskStatusId) {

    var taskStatusName = '';
    switch (taskStatusId) {
      case 1:
        taskStatusName = "Pending";
        break;
      case 2:
        taskStatusName = "Completed";
        break;
      case 3:
        taskStatusName = "Delayed Completion";
        break;
      case 4:
        taskStatusName = "Partially Completed";
        break;
      case 5:
        taskStatusName = "NA";
        break;
      case 6:
        taskStatusName = "Done";
        break;
      case 7:
        taskStatusName = "Cancelled";
        break;
      default:
        taskStatusName = "";
    }
    return taskStatusName;
  }

  showAllTasks() {
    this.response = true;
    this.getActivatedTaskList();
    // $("#groupdropdown").val(null);
    // $("#taskStatusdropdown").val(null);
    this.SearchtaskEventbasedorPeriodicModel = null;
    this.SearchtaskUserdefinedorPredefinedModel = null;
    this.IsEmailSend = null;
    this.selcettaskname = null;
    this.groupname = null;
    this.activatedTaskSearchDateFrom = null;
    this.activatedTaskSearchDateTo = null;
    if (this.taskStatusID != "2") {
      this.taskStatusID = null;
    }
    localStorage.setItem('searchtaskc', 'false');
    this.selectedProcessCount = 0;
    this.selectedEventBaseCount = 0;
    this.triggerId = null;
  }

  selectAll() {
    var self = this;

    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      var filterValues = dtInstance.column(0, { search: 'applied' }).data()
      if (_.size(filterValues) && this.selectedAll) {
        for (let index = 0; index < _.size(filterValues); index++) {
          let indexOfCompanyTaskElement = _.findIndex(this.companytasklist, function (element) { return element._id == filterValues[index] });
          this.companytasklist[indexOfCompanyTaskElement].SelectedTask = true
        }
        this.IsSelectedTasks = this.selectedAll;
        this.onlySenEmailTaskButtonEnable = true;
      } else if (this.selectedAll) {
        for (var i = 0; i < this.companytasklist.length; i++) {
          this.companytasklist[i].SelectedTask = this.selectedAll;
          this.IsSelectedTasks = this.selectedAll;
          this.onlySenEmailTaskButtonEnable = true;
        }
      } else {
        for (var i = 0; i < this.companytasklist.length; i++) {
          this.companytasklist[i].SelectedTask = false;
          this.IsSelectedTasks = false;
          this.onlySenEmailTaskButtonEnable = true;
        }
      }
    });

  }

  EditTask(taskId) {
    // console.log(taskId)
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['tasks', 'activated', 'update', taskId] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/tasks/activated/update/', taskId]);
  }

  CreateTask() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['addTask'] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['tasks/addTask']);
  }

  EditReminderFrequency() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['tasks', 'editReminderFrequecies'] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['tasks/editReminderFrequecies']);
  }

  showSendImmediateReminderMailDialog() {

    this.immediateReminderMailSelectedCompanytasks = [];

    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;

    var sendImmediateReminderStatus = false;


    for (let result of this.companytasklist) {

      if (result.SelectedTask === true) {

        result.CompanyID = companyID;

        // Check Task Status to send Immediate Reminder
        // Task Status Should be Pending = 1, Done = 4, Partially Completed = 6;
        if (result.TaskStatus == 1 || result.TaskStatus == 4 || result.TaskStatus == 6) {
          sendImmediateReminderStatus = true;
          this.immediateReminderMailSelectedCompanytasks.push(result);
        }
        else {
          sendImmediateReminderStatus = false;
          break;
        }

      }

    }

    if (sendImmediateReminderStatus) {
      // Clean any leftover state just to be safe
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
      $('#immediateReminder').removeClass('show').hide();

      setTimeout(() => {
        $('#immediateReminder').modal('show');
      }, 100);
    } else {
      $('#immediateReminder').modal('hide');
      this.alert.successWithOk1("Please select only those task which are having status Pending, Partially Completed or Done", () => {
        $('#immediateReminder').off('hidden.bs.modal');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

      });
    }

  }
  showEmailStatusDialog() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#sendEmailToSelectedTask').removeClass('show').hide();

    setTimeout(() => {
      $('#sendEmailToSelectedTask').modal('show');
    }, 100);

    this.IsSelectedUpload = false;
    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValue('1');
    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValidators([Validators.required]);
    this.uploadProofactivatedTaskForm.controls.TaskStatus.updateValueAndValidity();
    this.uploadProofactivatedTaskForm.controls.CompletedDate.setValidators([Validators.required]);
    this.uploadProofactivatedTaskForm.controls.CompletedDate.updateValueAndValidity();
  }
  showStatusandUploadProofDialog() {
    // Clean any leftover state just to be safe
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#uploadProofDialog').removeClass('show').hide();

    setTimeout(() => {
      $('#uploadProofDialog').modal('show');
    }, 100);

    this.IsSelectedUpload = false;
    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValue('1');
    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValidators([Validators.required]);
    this.uploadProofactivatedTaskForm.controls.TaskStatus.updateValueAndValidity();
    this.uploadProofactivatedTaskForm.controls.CompletedDate.setValidators([Validators.required]);
    this.uploadProofactivatedTaskForm.controls.CompletedDate.updateValueAndValidity();
  }

  count: number = 0;

  checkselected(ev) {

    if (ev.target.checked == true) {
      this.count = this.count + 1;
      this.IsSelectedTasks = true;
    }
    else {
      this.count = this.count - 1;

      if (this.count > 0) {
        this.IsSelectedTasks = true;
        this.onlySenEmailTaskButtonEnable = true;
      } else {
        this.IsSelectedTasks = false;
        this.onlySenEmailTaskButtonEnable = false;
      }
    }

    var allSearchedSelected = true;
    if (_.size(this.companytasklist)) {
      for (var i = 0; i < this.companytasklist.length; i++) {
        // for (var j = 0; j < this.searcheFilteredDataTask.length; j++) {
        // if (this.searcheFilteredDataTask[j] == this.companytasklist[i]._id) {
        if (this.companytasklist[i].SelectedTasks) {
        } else {
          allSearchedSelected = false;
        }
        // }
        // }
      }
    }
    if (allSearchedSelected) {
      this.selectedAll = true;
    } else {
      this.selectedAll = false;
    }

  }

  selectedProcessCount: number = 0;
  selectedEventBaseCount: number = 0;
  selectDataType: boolean = true;
  setStatusOfProcessButton() {
    if (this.selectedProcessCount > 0) {
      this.selectDataType = true
    } else if (this.selectedProcessCount == 0 && this.selectedEventBaseCount > 0) {
      this.selectDataType = false
    }
  }

  checkIfAllSelected(event, TriggerType, TaskStatus, id) {
    var self = this;
    if (event.target.checked == true) {
      // self.Records = [];
      self.selectedAll = self.companytasklist.every(function (item: any) {

        // self.Records.push(item);
        return item.SelectedTask == true;

      })
      // for (var i = 0; i <= self.Records.length; i++) {

      // }
      if (TriggerType == '2' || TriggerType == 2) {
        self.selectedProcessCount = self.selectedProcessCount + 1
      }
      if (TriggerType == '1' || TriggerType == 1) {
        self.selectedEventBaseCount = self.selectedEventBaseCount + 1
      }
      self.onlySenEmailTaskButtonEnable = true;
    }
    else {
      // for (var ind = 0; ind < self.Records.length; ind++) {
      //   // if (self.Records[ind]._id === id) {
      //   //   self.Records.splice(ind, 1);
      //   // }
      // }

      if (TriggerType == '2' || TriggerType == 2) {
        self.selectedProcessCount = self.selectedProcessCount - 1
      }
      if (TriggerType == '1' || TriggerType == 1) {
        self.selectedEventBaseCount = self.selectedEventBaseCount - 1
      }
      self.onlySenEmailTaskButtonEnable = false;
    }
    // console.log("records" + JSON.stringify(self.Records));
    self.selectedAll = self.companytasklist.every(function (item: any) {

      return item.SelectedTask == true;

    })
  }

  sendImmediateReminderMail() {

    var userType = {
      To: {
        AssignedTo: this.ToAssignedTo,
        OneEscalation: this.OneEscalation,
        TwoEscalation: this.TwoEscalation,
        ResponsibleUser: this.ResponsibleUser,
        ResponsibleUserone: this.ResponsibleUserone,
        ResponsibleUsertwo: this.ResponsibleUsertwo,
      },
      Cc: {
        AssignedTo: this.AssignedTocc,
        OneEscalation: this.OneEscalationcc,
        TwoEscalation: this.TwoEscalationcc,
        ResponsibleUser: this.ResponsibleUsercc,
        ResponsibleUserone: this.ResponsibleUseronecc,
        ResponsibleUsertwo: this.ResponsibleUsertwocc,
        Collegues: this.Collegues
      }
    };

    // console.log(this.immediateReminderMailSelectedCompanytasks);
    var parameters = {
      userType: userType,
      selectedTaskList: this.immediateReminderMailSelectedCompanytasks
    };

    this.taskService.SendImmediateRemainderEmail(parameters)
      .subscribe(result => {
        if (result.status == 0) {
          // console.log(result);
          $('#immediateReminder').modal('hide');
          this.alert.successWithOk1(result.message,()=>{
            $('#immediateReminder').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
          });
        }
        else {
          $('#immediateReminder').modal('hide');
          this.alert.error1(result.message,()=>{
            $('#immediateReminder').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
          });
        }

        // this.getActivatedTaskList();
        // this.selectedCompanytasks = [];
        // this.IsSelectedTasks = false;
      });


    // this.IsSelectedUpload = false;
    // this.uploadProofactivatedTaskForm.controls.TaskStatus.setValue('1');
    // this.uploadProofactivatedTaskForm.controls.TaskStatus.setValidators([Validators.required]);
    // this.uploadProofactivatedTaskForm.controls.TaskStatus.updateValueAndValidity();
    // this.uploadProofactivatedTaskForm.controls.CompletedDate.setValidators([Validators.required]);
    // this.uploadProofactivatedTaskForm.controls.CompletedDate.updateValueAndValidity();
    this.ToAssignedTo = false;
    this.OneEscalation = false;
    this.TwoEscalation = false;
    this.ResponsibleUser = false;
    this.ResponsibleUserone = false;
    this.ResponsibleUsertwo = false;
    this.AssignedTocc = false;
    this.OneEscalationcc = false;
    this.TwoEscalationcc = false;
    this.ResponsibleUsercc = false;
    this.ResponsibleUseronecc = false;
    this.ResponsibleUsertwocc = false;
    this.Collegues = false;

  }

  closeImmediateReminderMail() {

    this.ToAssignedTo = false;
    this.OneEscalation = false;
    this.TwoEscalation = false;
    this.ResponsibleUser = false;
    this.ResponsibleUserone = false;
    this.ResponsibleUsertwo = false;
    this.AssignedTocc = false;
    this.OneEscalationcc = false;
    this.TwoEscalationcc = false;
    this.ResponsibleUsercc = false;
    this.ResponsibleUseronecc = false;
    this.ResponsibleUsertwocc = false;
    this.Collegues = false;

  }

  sentIntimationFormValid(event) {

    if (this.ToAssignedTo || this.OneEscalation || this.TwoEscalation || this.ResponsibleUser || this.ResponsibleUserone || this.ResponsibleUsertwo) {
      this.IsSentIntimationFormValid = true;
    }
    else {
      this.IsSentIntimationFormValid = false;
    }
  }

  sendremindermails() {

    let taskid = [];

    for (let result of this.companytasklist) {
      if (result.SelectedTask === true) {
        // taskid.push("ObjectId"+"("+result._id+")");
        taskid.push(result._id);

      }
    }

    // console.log("taskid", taskid);

    this.taskService.sendremindermails(taskid)
      .subscribe((data: any) => {
        if (data) {
          this.alert.success(data.message);

        }
        else {
          this.alert.error(data.message);

        }
      });


  }



  onFileChange(event) {
    let reader = new FileReader();
    this.IsSelectedUpload = true;
    if (event.target.files && event.target.files.length > 0) {
      // this.filesToUpload = <Array<File>>event.target.files;
      var checkfile = this.commonFunction.checkFileExtension(event);
      if (checkfile) {
        this.filesToUpload = <Array<File>>event.target.files;
        this.fileExtension = true;
      } else {
        this.fileExtension = false;
      }

      this.IsSelectedUpload = true;
      let file = event.target.files[0];
      this.originalfileName = file.name;
      const formData: FormData = new FormData();
      formData.append('file', file, file.name);
      const headers = new Headers();
      headers.append('Content-Type', 'multipart/form-data');
      this.fileUpload = formData
      reader.readAsDataURL(file);
      // console.log('event', event);
      reader.onload = () => {
        // console.log('filename', file.name);
        // console.log('filename', this.fileUpload);
      };
    }
  }

  uploadProofDocument() {
    this.disabledOnclick = true;

    if (this.filesToUpload == undefined && this.IsSelectedUpload === false) {

      for (let result of this.companytasklist) {
        if (result.SelectedTask === true) {
          var newDocumentManagement = {
            "DocumentManagement":
            {
              DocumentName: result.TaskName,
              DateOfDocument: new Date(),
              Upload: this.orignalName,
              MeetingTypeID: null,
              ParentDocumentTypeID: null,
              ParentSubDocumentTypeID: null,
              DirectorKmp: "None",
              DirectorID: null,
              KMPID: null,
              Remarks: "",
              OriginalFileName: this.originalfileName,
              DocumentID: result.DocumentID,
              ActivatedTaskID: result._id,
              TaskStatus: (this.uploadProofactivatedTaskForm.controls.TaskStatus.value == '0') ? 1 : this.uploadProofactivatedTaskForm.controls.TaskStatus.value,
              CompletedDate: this.commonFunction.setDate(this.uploadProofactivatedTaskForm.controls.CompletedDate.value)
            }
          }

          this.selectedNewDocumentCompanytasks.push(newDocumentManagement);

        }

      }

      var SelectedDocumentTasks = {
        selectedDocumentTasks: this.selectedNewDocumentCompanytasks
      }

      this.taskService.updateTaskStatusforMultipleactivatedTasks(SelectedDocumentTasks)
        .subscribe(documentManagement => {
          this.disabledOnclick = false;
          if (documentManagement.status == 0) {
            // console.log("documentManagement" + documentManagement);

            $('#uploadProofDialog').modal('hide');
            this.alert.successWithOk1(documentManagement.message, () => {
              $('#uploadProofDialog').off('hidden.bs.modal');
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');

            });
            this.getActivatedTaskList();
            this.selectedNewDocumentCompanytasks = [];
            //this.updateDocumentProofID(documentManagement.result._id);
          }
          else {
            $('#uploadProofDialog').modal('hide');
            this.alert.error1(documentManagement.message, () => {
              $('#uploadProofDialog').off('hidden.bs.modal');
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');

            });
          }

        });
    }
    else {

      this.fileName = this.uploadProofactivatedTaskForm.controls.fileData.value;

      if (this.filesToUpload == undefined) {
        this.IsSelectedUpload = true;
        return false;
      }
      this.upload();

      // var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
      // var companyID = companyDetails.companyID;
      // this.companytasklist;
      for (let result of this.companytasklist) {
        if (result.SelectedTask === true) {
          var newDocumentManagement = {
            "DocumentManagement":
            {
              DocumentName: result.TaskName,
              DateOfDocument: new Date(),
              Upload: this.orignalName,
              MeetingTypeID: null,
              ParentDocumentTypeID: null,
              ParentSubDocumentTypeID: null,
              DirectorKmp: "None",
              DirectorID: null,
              KMPID: null,
              Remarks: "",
              OriginalFileName: this.originalfileName,
              DocumentID: result.DocumentID,
              ActivatedTaskID: result._id,
              //TaskStatus: this.uploadProofactivatedTaskForm.controls.TaskStatus.value,
              TaskStatus: (this.uploadProofactivatedTaskForm.controls.TaskStatus.value == '0') ? 1 : this.uploadProofactivatedTaskForm.controls.TaskStatus.value,
              CompletedDate: this.commonFunction.setDate(this.uploadProofactivatedTaskForm.controls.CompletedDate.value)
            }
          }

          this.selectedNewDocumentCompanytasks.push(newDocumentManagement);

        }

      }

      var SelectedDocumentTasks = {
        selectedDocumentTasks: this.selectedNewDocumentCompanytasks
      }

      this.documentManagementService.addMultipleDocuments(SelectedDocumentTasks)
        .subscribe((documentManagement: any) => {
          this.disabledOnclick = false;
          if (documentManagement.status == 0) {
            // console.log("documentManagement" + documentManagement);
            $('#uploadProofDialog').modal('toggle');
            this.alert.success(documentManagement.message);
            this.getActivatedTaskList();
            //this.updateDocumentProofID(documentManagement.result._id);
          }
          else {
            $('#uploadProofDialog').modal('toggle');
            this.alert.error(documentManagement.message);
          }

        });

    }



    //   console.log("docid"+ this.documentId);
    //   if(this.documentId=="" || this.documentId==null || this.documentId===undefined)
    //   {

    //     var newDocumentManagement = {
    //       "DocumentManagement":
    //         {
    //           DocumentName: "",
    //           DateOfDocument: new Date(),
    //           Upload: this.orignalName,
    //           OriginalFileName: this.originalfileName
    //         }
    //     }
    //     this.documentManagementService.addDocumentManagement(newDocumentManagement)
    //        .subscribe(documentManagement => {
    //         if (documentManagement.status == 0) {
    //           this.updateDocumentProofID(documentManagement.result._id);
    //         }
    //          else {
    //           $('#uploadProofDialog').modal('toggle');
    //           this.alert.error(documentManagement.message);
    //         }

    //       });

    //   }
    //  else
    //   {

    //     var updatedDocumentManagement = {
    //       _id: this.documentId,
    //       DocumentName: this.uploadProofactivatedTaskForm.controls.TaskName.value,
    //       DateOfDocument: new Date(),
    //       Upload: this.orignalName,
    //       OriginalFileName: this.originalfileName
    //     }

    //     this.documentManagementService.updateDocumentManagement(updatedDocumentManagement)
    //     .subscribe(documentManagement => {
    //       if (documentManagement.status == 0) {
    //         $('#uploadProofDialog').modal('toggle');
    //         this.alert.success("document uploaded successfully");
    //       }
    //       else
    //       {
    //         $('#uploadProofDialog').modal('toggle');
    //         this.alert.error("error occured on uploading file");
    //       }
    //     })

    //   }
  }

  updateSendEmailCondition() {
    this.disabledOnclick = true;
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var companyID = companyDetails.companyID;
    this.selectedCompanytasksSendEmail = [];
    for (let result of this.companytasklist) {
      if (result.SelectedTask === true) {
        result.CompanyID = companyID;
        result.EmailSendForTask = this.IsEmailSendActivatedTask;
        this.selectedCompanytasksSendEmail.push(result);
      }

    }

    var processTasksData = {
      processTasks: this.selectedCompanytasksSendEmail
    }
    //this.taskService.updateCompanyTasks(companyTasks)

    this.taskService.addActivatedTaskstoProcessEmailSend(processTasksData)
      .subscribe(result => {
        this.disabledOnclick = false;
        if (result.status == 0) {
          $('#sendEmailToSelectedTask').modal('hide');
          this.alert.successWithOk1(result.message, () => {
            $('#sendEmailToSelectedTask').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

          });
        }
        else {
          $('#sendEmailToSelectedTask').modal('hide');
          this.alert.error1(result.message, () => {
            $('#sendEmailToSelectedTask').off('hidden.bs.modal');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');

          });
        }

        this.getActivatedTaskList();
        this.selectedCompanytasks = [];
        this.IsSelectedTasks = false;
      });
  }

  initialiseJqueryEvents() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
  }

  getTodaysDate() {
    var newDate = new Date();
    this.todaysDate = { year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate() };
  }

  refreshOnLoadTaskList() {
    var self = this;
    setTimeout(function () {
      // console.log('refreshing data');
      self.refreshTaskList();
    }, 500)
  }


  refreshTaskList() {
    if (this.currentURL.includes('edit')) {
      var table = $('#companytaskTable').DataTable({ destroy: true });
      table.destroy();
      this.getActivatedTaskList();
    } else {
      var table = $('#companytaskTable').DataTable({ destroy: true });

      table.destroy();
      this.getActivatedTaskList();
    }
    $("#groupdropdown").val("null");

    this.groupID = null;
    this.selectedAll = false;
    this.SearchtaskEventbasedorPeriodicModel = '1';
    this.IsEmailSend = null
    this.SearchtaskUserdefinedorPredefinedModel = null;
  }




  ngOnInit() {
    this.cronFrequencyData = [
      'Weekly',
      'Monthly'
    ];
    this.CronDates = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
    this.cronConfigurationForm = new FormGroup({
      dynamicFieldsArray: new FormArray([])
    });
    // this.addNewRow()
    this.selectedProcessCount = 0;
    this.selectedEventBaseCount = 0;
    this.environmentSettings = environment;

    // this.commonFunction.removeDataTableSaveStateKey("activatedcompanytaskTable");

    let searchflag = localStorage.getItem('searchtaskc');

    if (searchflag == 'true') {
      let searchnewdata = JSON.parse(localStorage.getItem('inputdata'));

      if (searchnewdata.EventBasedorPeriodic) {
        this.SearchtaskEventbasedorPeriodicModel = searchnewdata.EventBasedorPeriodic;
      }

      if (searchnewdata.UserdefinedorPredefined) {
        this.SearchtaskUserdefinedorPredefinedModel = searchnewdata.UserdefinedorPredefined;
      }

      if (searchnewdata.EmailSendForTask) {
        this.IsEmailSend = searchnewdata.EmailSendForTask;
      } else if (searchnewdata.EmailSendForTask == false) {
        this.IsEmailSend = false;
      } else {
        this.IsEmailSend = null;
      }

      if (searchnewdata.GroupId) {
        this.groupname = searchnewdata.GroupId;
      }

      if (searchnewdata.TaskStatusId) {
        this.selcettaskname = searchnewdata.TaskStatusId;
      }

      if (searchnewdata.FromDate) {
        let dt = new Date(this.commonFunction.setFormatDate(searchnewdata.FromDate))
        this.activatedTaskSearchDateFrom = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() }

      }
      if (searchnewdata.ToDate) {
        let dt2 = new Date(this.commonFunction.setFormatDate(searchnewdata.ToDate))
        this.activatedTaskSearchDateTo = { month: dt2.getMonth() + 1, day: dt2.getDate(), year: dt2.getFullYear() }
      }


      this.getActivatedTaskListBySearchFilter(searchnewdata);
      // console.log("in");

    }
    else {
      this.getActivatedTaskList();

    }

    this.initialiseJqueryEvents();
    this.getGroupmasterList();
    this.getProcessList();
    this.getassignedUsersList();
    this.getPeriodicTaskConfiguration();

    this.IsSelectedUpload = false;

    $('.datatabletool').hide();

    this.dtOptions = {
      destroy: true,
      scrollY: "300px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      stateSave: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [6, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1, 9] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Activated Task List',
          title: 'Activated Task List',
          extend: 'excel',
          exportOptions: {
            columns: [2, 3, 4, 5, 7, 9, 10, 12, 13, 14, 15, 16],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          }


        }
      ]

    };

    this.dtOptions1 = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 5,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };
    // this.refreshOnLoadTaskList()

    this.taskConfigurationForm = new FormGroup({
      EmailId: new FormControl('', []),
      FirstName: new FormControl('', []),
      LastName: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      UserId: new FormControl('', [Validators.required])
    });

    $('#activatedcompanytaskTable').on('draw.dt', function () {
      $('.datatabletool').show();

    });


    var self = this;
    // Function to setup search event handler
    var setupSearchEventHandler = function() {
      if (!$.fn.DataTable.isDataTable("#activatedcompanytaskTable")) {
        return false; // Return false if DataTable is not ready
      }

      try {
        let table1 = $("#activatedcompanytaskTable").DataTable();
        var searchedDataForSelectAll = [];

        table1.on('search.dt', function () {
          self.searcheFilteredDataTask = [];
          var tableData = $("#activatedcompanytaskTable").DataTable().column(0, { search: 'applied' }).data();
          for (var i = 0; i < tableData.length; i++) {
            self.searcheFilteredDataTask.push(tableData[i])
          }
          var alreadySelectedElamant = _.filter(self.companytasklist, function (element) { return element.SelectedTask == true })
          var value = $('.dataTables_filter input').val();
          var filterTaskListArray = [];
          for (var index = 0; index < _.size(tableData); index++) {
            var taskList = _.filter(self.companytasklist, function (element) { return element.SelectedTask == true && element._id == tableData[index] })
            filterTaskListArray = _.concat(filterTaskListArray, taskList)
          }
          if (_.size(alreadySelectedElamant) == _.size(tableData)) {
            self.selectedAll = true;
          } else if ((_.size(tableData) == _.size(filterTaskListArray)) && _.size(tableData) != 0 && _.size(filterTaskListArray) != 0) {
            self.selectedAll = true;
          } else {
            self.selectedAll = false;
          }
        });
        return true; // Successfully set up
      } catch (error) {
        console.warn('Error setting up search event handler:', error);
        return false;
      }
    };

    // Try to setup immediately, then retry if needed
    setTimeout(function () {
      if (!setupSearchEventHandler()) {
        // Retry after a longer delay if DataTable is not ready
        setTimeout(function() {
          if (!setupSearchEventHandler()) {
            // Final retry after even longer delay
            setTimeout(function() {
              setupSearchEventHandler();
            }, 1000);
          }
        }, 500);
      }
    }, 1000);


    this.uploadProofactivatedTaskForm = new FormGroup({
      fileData: new FormControl('', []),
      TaskStatus: new FormControl('', []),
      CompletedDate: new FormControl('', [])
    });

    this.activatedProcessTasksForm = new FormGroup({
      ProcessID: new FormControl('', []),
      IsPredefinedorUserdefined: new FormControl('', []),
      TaskStatus: new FormControl('', [])
    });

    this.selectedTaskForm = new FormGroup({
      IsEmailSendTask: new FormControl('', [])
    });

    this.getTodaysDate();

    this.uploadProofactivatedTaskForm.controls.TaskStatus.setValue('1');
    var moduleName = '';
    var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskAll"; })
    var libraryTasklistAdmin1 = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskIndividual"; })
    if (libraryTasklistAdmin == true) {
      moduleName = 'ActivatedTaskAll'
    }
    if (libraryTasklistAdmin1 == true) {
      moduleName = 'ActivatedTaskIndividual'
    }

    this.hasPermission = this.commonFunction.validateURL(moduleName, '');
  }

  //get policy type from enum
  getPolicyType(PolicyType) {
    if (PolicyType) {
      return Enums.policyType.find(x => x.id == PolicyType).name;
    } else {
      return " ";
    }
  }

  // get RiskType from enum
  getRiskType(RiskType) {
    if (RiskType) {
      return Enums.RiskTypes.find(x => x.id == RiskType).name;
    } else {
      return " ";
    }
  }

  /* Changes for configuration of periodic task (13-03-2019)*/
  getassignedUsersList() {
    this.assignedusers = [];

    // Use cached Observable instead of direct service call
    this.getCachedUsersList()
      .subscribe(result => {
        if (result.status == 0) {
          if (environment.PSS == true) {
            var userlist = [];
            var usersData = result.result;

            _.forEach(usersData, function (user) {
              var resources = user.Resources;
              var foundResource = resources[0].filter(function (element) {
                return element.Menu === "TaskSpecificUserRoles";
              });

              if (foundResource[0] != undefined) {
                var data = _.find(foundResource[0].ChildResources, function (Item) { return Item.ResourceType == "Assigned to"; });
                if (data != undefined) {
                  userlist.push(user);
                }
              }

            })
          } else {
            this.assignedusers = this.commonFunction.sortByKey(result.result, 'FirstName');
          }
        }
      })
  }

  selectedUserChange() {
    var self = this;
    var userId = this.taskConfigurationForm.controls.UserId.value
    _.forEach(this.assignedusers, function (user) {
      var foundResource = [user].filter(function (element) {
        return element._id == userId;
      });

      if (foundResource[0] != undefined) {
        self.taskConfigurationForm.controls.EmailId.setValue(foundResource[0].EmailId);
        self.taskConfigurationForm.controls.FirstName.setValue(foundResource[0].FirstName);
        self.taskConfigurationForm.controls.LastName.setValue(foundResource[0].LastName);
        self.taskConfigurationForm.controls.MobileNumber.setValue(foundResource[0].MobileNumber);

      }
    })
  }

  addPeriodicTaskConfiguration() {
    this.disabledOnclick = true;
    if (this.configId == '' || this.configId == undefined || this.configId == null) {
      var configAddObject = {
        AssignedUserId: this.taskConfigurationForm.controls.UserId.value,
        AssignedFirstName: this.taskConfigurationForm.controls.FirstName.value,
        AssignedLastName: this.taskConfigurationForm.controls.LastName.value,
        AssignedMobileNumber: this.taskConfigurationForm.controls.MobileNumber.value,
        AssignedEmailId: this.taskConfigurationForm.controls.EmailId.value
      }
      this.taskService.addPeriodicTaskConfiguration(configAddObject)
        .subscribe(result => {
          this.disabledOnclick = false;
          if (result.status == 0) {
            $('#configureSettingsDialog').modal('toggle');
            this.alert.success(result.message);
            this.getPeriodicTaskConfiguration();
          }
          else {
            this.alert.error(result.message);
          }
        });
    } else {
      var configUpdateObject = {
        AssignedUserId: this.taskConfigurationForm.controls.UserId.value,
        AssignedFirstName: this.taskConfigurationForm.controls.FirstName.value,
        AssignedLastName: this.taskConfigurationForm.controls.LastName.value,
        AssignedMobileNumber: this.taskConfigurationForm.controls.MobileNumber.value,
        AssignedEmailId: this.taskConfigurationForm.controls.EmailId.value
      }
      this.taskService.updatePeriodicTaskConfiguration(this.configId, configUpdateObject)
        .subscribe(result => {
          this.disabledOnclick = false;
          if (result.status == 0) {
            $('#configureSettingsDialog').modal('toggle');
            this.getPeriodicTaskConfiguration();
            this.alert.success(result.message);

          }
          else {
            this.alert.error(result.message);
          }
        });
    }

  }

  getPeriodicTaskConfiguration() {
    this.taskService.getPeriodicTaskConfiguration().subscribe(result => {
      if (result.data.length > 0) {
        var configData = result.data[0];
        this.isPeriodicConfigurationAvailable = false;
        this.configId = result.data[0]._id;
        this.taskConfigurationForm.controls.UserId.setValue(configData.PeriodicTaskConfiguration.AssignedUserId);
        this.taskConfigurationForm.controls.FirstName.setValue(configData.PeriodicTaskConfiguration.AssignedFirstName);
        this.taskConfigurationForm.controls.LastName.setValue(configData.PeriodicTaskConfiguration.AssignedLastName);
        this.taskConfigurationForm.controls.MobileNumber.setValue(configData.PeriodicTaskConfiguration.AssignedMobileNumber);
        this.taskConfigurationForm.controls.EmailId.setValue(configData.PeriodicTaskConfiguration.AssignedEmailId);
      }
    })
  }

  CheckTriggerType(item: any) {
    this.getTriggerTypeListByTriggerType(item);
  }

  getTriggerTypeListByTriggerType(triggerType) {
    this.taskTriggerTypes = [];

    this.taskService.getTriggerTypeListByTriggerType(triggerType)
      .subscribe(tasktriggerList => {
        if (tasktriggerList.status == 0) {
          this.taskTriggerTypes = tasktriggerList.tasktriggerList;
        }
      })
  }

  initiateUploadProof() {
    var filteredTaskList = _.filter(this.companytasklist, function (element) {
      return element.SelectedTask == true
    })
    if (filteredTaskList.length > 1) {
      this.alert.success('Proof can be uploaded for only one task at a time')
    } else if (filteredTaskList.length == 0) {
      this.alert.error('Please select one task to upload proof')
    } else {
      this.taskId = filteredTaskList[0]._id;
      this.getTaskProofFiles();
      $("#uploadProofDialogTitle").html("Task Proof");
      $("#uploadProofDialog1").modal('toggle');
    }
  }

  proofChangeEvent(fileInput: any) {
    this.typeHasError = false
    var checkfile = this.commonFunction.checkFileExtension(fileInput);
    if (checkfile) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
      this.typeHasError = false;
    } else {
      this.typeHasError = true;
    }
  }

  uploadProofFile() {
    var file = this.filesToUpload;
    var self = this;
    var pdfData = [];
    this.insertFileIndividuallyInDocumentForPdf('Task Proof', file, 'Attachment').then(function (response) {

      // console.log(response);
      if (response.status == 0) {
        for (var i = 0; i < response.result.length; i++) {
          var data = {
            IsAvailable: true,
            TaskId: self.taskId,
            DocumentManagementID: response.result[i].Document._id,
            UploadDate: new Date(),
            IsPublished: true,
            DocName: response.result[i].Document.OriginalFileName,
            UploadFileName: response.result[i].Document.Filename,
          }
          pdfData.push(data);
        }
        self.taskService.uploadTaskProof(pdfData).subscribe(responseData => {
          self.alert.success("Proof File Uploaded Successfully");
          self.getTaskProofFiles()
          self.filesToUpload = undefined;
          $(".fileUpload").val("");
        })
      } else {
        self.alert.error(response.message);
      }
    }, (error) => {
      this.alert.error(error);
    })
  }

  insertFileIndividuallyInDocumentForPdf(fileFor, file, type): Promise<any> {
    return this.makeFileRequest2(environment.pssServerUrl + "documentManagement/taskProofFileUpload/", [], file, fileFor, type).then((result) => {
      // console.log(result);
      if (result) {
        return this.documentManagementService.addMultiplePdfDocuments(result)
          .toPromise().then(res => { return Promise.resolve(res); })
        // documentManagement/--Post
      }
    })
  }

  makeFileRequest2(url: string, params: Array<string>, files: Array<File>, fileFor, type) {
    var pdfArray = [];
    return new Promise((resolve, reject) => {
      var formData: any = new FormData();
      var xhr = new XMLHttpRequest();
      var now = Date.now();
      for (var i = 0; i < files.length; i++) {
        var name = now + '-' + files[i].name.replace(',', '');
        name = name.replace(new RegExp('\\(', 'g'), '');
        name = name.replace(new RegExp('\\)', 'g'), '');
        formData.append("file", files[i], name);
        this.FileOrignalName = files[i].name.replace(',', '');
        this.changedName = name;

        var documentManagement = {
          "DocumentManagement": {
            DocumentName: this.titleOnAddUpdate + '- Documents-' + Date.now() + fileFor + ' ' + type + ' - ' + this.FileOrignalName,
            DateOfDocument: new Date(),
            Upload: this.changedName,
            OriginalFileName: this.FileOrignalName,
            CompletedDate: null,
            DirectorID: null,
            DirectorKmp: "None",
            KMPID: null,
            MeetingTypeID: null,
            Overwrite: false,
            ParentDocumentTypeID: null,
            ParentSubDocumentTypeID: null,
            Remarks: null
          }
        }

        pdfArray.push(documentManagement);
        this.pdfArray1.push(documentManagement);
        // console.log(this.pdfArray1);

      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            resolve(pdfArray);
          } else {
            reject(xhr.response);
          }
        }
      }
      xhr.open("POST", url, true);
      var token = localStorage.getItem('token')
      xhr.setRequestHeader('x-access-token', token)
      xhr.send(formData);
    });
  }

  getTaskProofFiles() {
    this.taskService.getTaskProofFiles(this.taskId)
      .subscribe(taskProofResponse => {
        if (taskProofResponse.status == 0) {
          $("#groupTable").DataTable().destroy();
          this.taskProofData = []
          this.taskProofData = taskProofResponse.data.TaskProof;
          setTimeout(() => {
            this.dtTrigger.next();
          }, 100);
          setTimeout(() => {
            $("#groupTable").DataTable().columns.adjust().draw();
          }, 200);
        }
      })
  }

  downloadDoc(downloadDocumentID) {
    this.taskService.downloadTaskProof(downloadDocumentID)
  }

  deleteProofDoc(pdfId, documentId) {
    $("#deletePdfConfirmation").modal('toggle');
    this.pdfToDelete = pdfId;
    this.documentIdToDelete = documentId
  }

  removeDoc() {
    this.taskService.removeTaskProof(this.taskId, this.documentIdToDelete, this.pdfToDelete).subscribe(responseData => {
      if (responseData) {
        this.getTaskProofFiles();
      }
    });
  }

  getTaskCronDetails() {
    this.taskService.getTaskCronDetails().subscribe(result => {
      if (result.data.length > 0) {
        var self = this;
        self.cronConfigurationForm = new FormGroup({
          dynamicFieldsArray: new FormArray([])
        });
        self.cronConfigurations = [];

        // self.cronFrequencyData = [
        //   'Weekly',
        //   'Every 2 weeks',
        //   'Monthly',
        //   'Every 2 months',
        //   'Every 3 months',
        //   'Start of quarter',
        //   'End of quarter'
        // ];
        // self.CronDates = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]

        result.data[0].CronConfigurations.forEach(function (element) {
          // console.log(element)
          var formArray: FormArray = <FormArray>self.cronConfigurationForm.controls.dynamicFieldsArray;
          var formArraySize = _.size(formArray.controls);

          formArray.push(self.cronConfigurationFormDesign());
          var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];
          // console.log(element.cronFrequency)
          formGroup.addControl("cronFrequency", new FormControl(element.cronFrequency, [Validators.required]));
          formGroup.addControl("weeklyDay", new FormControl(element.weeklyDay, [Validators.required]));
          formGroup.addControl("cronDate", new FormControl(element.cronDate, [Validators.required]));

          // // console.log("formGroup", formGroup);
          var newLogicAttribute = { 'cronName': element.cronName, 'cronFrequency': element.cronFrequency, 'weeklyDay': element.weeklyDay, 'cronDate': element.cronDate, 'emailTo': element.emailTo, 'noOfDays': element.noOfDays };
          self.cronConfigurations.push(newLogicAttribute);

        })
        self.addBtn = false;
      } else {
        this.cronConfigurationForm = new FormGroup({
          dynamicFieldsArray: new FormArray([])
        });
        this.cronConfigurations = [];
        this.addNewRow()
        this.addBtn = true;
      }
    })
  }

  cronConfigurationFormDesign(): FormGroup {
    return this.fb.group({
      cronFrequency: ['', [Validators.required]],
      weeklyDay: ['', [Validators.required]],
      cronDate: ['', [Validators.required]],
      // scripCode: ['', [Validators.required]],
      // dateOfCorporateAction: ['', [Validators.required]],
    });
  }

  // addNewRow() {
  //   console.log(this.cronConfigurationForm)
  //   var formArray: FormArray = <FormArray>this.cronConfigurationForm.controls.dynamicFieldsArray;
  //   var formArraySize = _.size(formArray.controls);

  //   formArray.push(this.cronConfigurationFormDesign());
  //   var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

  //   formGroup.addControl("cronFrequency", new FormControl('', [Validators.required]));
  //   formGroup.addControl("weeklyDay", new FormControl('', [Validators.required]));
  //   formGroup.addControl("cronDate", new FormControl('', [Validators.required]));

  //   // // console.log("formGroup", formGroup);
  //   var newLogicAttribute = { 'cronFrequency': '', 'weeklyDay': '', 'cronDate': '' };
  //   this.cronConfigurations.push(newLogicAttribute);
  // }

  addNewRow() {
    var tempObject = Object.assign([], this.cronConfigurations);
    tempObject.push({ 'cronName': '', 'cronFrequency': '', 'weeklyDay': '', 'cronDate': '', 'noOfDays': '', 'emailTo': '' })

    // console.log(tempObject)
    this.cronConfigurations = [];
    this.cronConfigurations = Object.assign([], tempObject)
    // var newLogicAttribute = { 'cronFrequency': '', 'weeklyDay': '', 'cronDate': '' };
    // this.cronConfigurations.push(newLogicAttribute);
    // console.log(this.cronConfigurations)

  }

  removeField(index) {
    // var newFieldData = this.cronConfigurationForm.controls.logic.value;
    this.cronConfigurations.splice(index, 1);
    // var formArray = <FormArray>this.cronConfigurationForm.controls.dynamicFieldsArray;
    // formArray.removeAt(index)
  }

  getCronConfigurationForm(index): FormGroup {
    var contactList = this.cronConfigurationForm.get('dynamicFieldsArray') as FormArray;
    const formGroup = contactList.controls[index] as FormGroup;
    return formGroup;
  }

  saveCronConfiguration() {
    this.disabledOnclick = true;
    this.taskService.saveCronConfigurations(this.cronConfigurations).subscribe(result => {
      if (result) {
        this.disabledOnclick = false;
        this.alert.success('Configuration added successfully')
      } else {
        this.alert.error('Oops something went wrong')
      }
    })
  }

  ngOnDestroy(): void {
    // Clear cached Observables to prevent memory leaks
    this.cachedUsersList$ = null;
  }

  updateCronConfiguration() {
    this.disabledOnclick = true;
    this.taskService.updateCronConfigurations(this.cronConfigurations).subscribe(result => {
      if (result) {
        this.disabledOnclick = false;
        this.alert.success('Configuration updated successfully')
      } else {
        this.alert.error('Oops something went wrong')
      }
    })
  }
}
